/**
 * The Stage: PlayerRow (top) · BoardFrame · PlayerRow (bottom).
 *
 * The column is exactly as wide as the board frame, so the two player rows span
 * the board and nothing else — the rows must not stretch across the whole row
 * when the rail is narrow.
 *
 * Fix D / R4 adds the eval bar. It hangs off the LEFT of the board's own slot
 * (`position: absolute`, negative left), so turning the engine on does not change
 * the column's width and therefore does not change the player rows or the board.
 *
 * Fix G (G5) adds `TournamentIdle`, unconditionally, as another SIBLING of the
 * board frame inside the same slot — it returns null whenever there is
 * nothing to say (a game of mine, or no tournament open), so it costs this
 * leaf nothing beyond its own model's subscriptions.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {LAYOUT} from '../../theme/useV2Ui';
import BoardFrame from '../BoardFrame';
import EvalBar from '../EvalBar';
import PlayerRow from '../PlayerRow';
import TournamentIdle from '../TournamentIdle';
import {StageModel} from './model';

export default React.memo(function StageView({
  top,
  bottom,
  width,
  analysis,
}: StageModel) {
  return (
    <View style={[styles.stage, {width}]}>
      <PlayerRow side={top} />
      <View style={styles.boardSlot}>
        {analysis && <EvalBar />}
        <BoardFrame />
        <TournamentIdle />
      </View>
      <PlayerRow side={bottom} />
    </View>
  );
});

const styles = StyleSheet.create({
  stage: {
    gap: LAYOUT.stageGap,
    alignSelf: 'flex-start',
    flexGrow: 0,
    flexShrink: 0,
  },
  // the anchor the eval bar hangs off; it adds no box of its own
  boardSlot: {
    position: 'relative',
  },
});
